import { useAppContext } from "app/AppContext";
import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Tabela from "components/Tabela Grid";
import { Box, CircularProgress, IconButton, Typography } from "@mui/material";
import { Edit } from "@mui/icons-material";
import _ from "lodash";
import DataFilter from "components/DataFilter";
import DataFilterTextField from "components/DataFilter/DataFilterTextField";
import { filterCollection, filterList } from "components/DataFilter/filter";
import DataFilterDatePicker from "components/DataFilter/DataFilterDatePicker";
import DataFilterCollection from "components/DataFilter/DataFilterCollection";
import RelatorioResumoGemas from "../../relatorios/RelatorioResumoGemas";


import DialogRelatorios from "OkReport/componentes/DialogRelatorios";
import LaudoVisitaReportButton from "entity/LaudoVisita/components/LaudoVisitaList/LaudoVisitaReportButton";
import { /*useInDebug,*/ usePerfil } from "useAuth";
import { DebugCSV, DebugCSVIndicadores, DebugCSVTipoIndicadores } from "routes/private/LaudoVisita/functions"
import { getColDataCustomForm } from "entity/dbApiForms";

const uidVisita = "sSCy71ONYFEwlGVDK4kK";

export default function ConsultaVisitaRelatorios() {
    const [showDialogRelatorios, setShowDialogRelatorios] = useState(false);
    const [loading, setLoading] = useState(false);
    const [listaOriginal, setListaOriginal] = useState(null);
    const [listaPesquisa, setListaPesquisa] = useState(null);
    // const INDEBUG = useInDebug();
    const [filters, setFilters] = useState();
    const navigate = useNavigate();
    const perfil = usePerfil()

    const { useSetTitle } = useAppContext();
    useSetTitle("Consulta de Visitas");

    let tipoPerfil = 'cliente'
    if (perfil) {
        if (perfil.grupoPermissao) {
            if (perfil.grupoPermissao.uid === "r9jrEQXznNgjrZTGCfch") {
                tipoPerfil = 'admin'
            }
            if (perfil.grupoPermissao.uid === "RECT03jkyTQW9B2OMz47") {
                tipoPerfil = 'tecnico'
            }
            if (perfil.grupoPermissao.uid === "-OXwisN4fkQV3l7Uzeui") {
                tipoPerfil = 'lider'
            }
        }
    }

    let colunas = [
        { field: "COL_EDIT", label: "Ações", sizecol: "80" },
        { field: "sequencialIndex", label: "Visita Nº", sizecol: "80" },
        { field: "data", label: "Data da Visita", sizecol: "135" },
        { field: "status", label: "Status", sizecol: "120" },
        { field: "cliente.nome", label: "Cliente" },
        { field: "fazenda.nomeFazenda", label: "Fazenda" },
        { field: "tecnico.nome", label: "Técnico", sizecol: "150" },
    ];

    useEffect(() => {
        const aplicaPermissoesPerfil = (col) => {
            if (perfil) {
                if (tipoPerfil === "cliente") col = col.where('cliente.perfisAutorizado', 'array-contains', perfil.uid);
                if (tipoPerfil === "tecnico") col = col.where('tecnico.uid', '==', perfil.uid);
                if (tipoPerfil === "lider") {
                    // se mais de 10 clientes, pode ser que precisaremos de uma nova abordagem
                    // existe um limitador de 10 no operador 'in'
                    if (perfil.clientesPermitidos && Array.isArray(perfil.clientesPermitidos) && perfil.clientesPermitidos.length > 0) {
                        col = col.where('cliente.uid', 'in', perfil.clientesPermitidos.map(cliente => cliente.uid));
                    }
                }
            }
            return col;
        }
        setListaPesquisa(null);

        let collection = getColDataCustomForm({ uid: uidVisita });

        collection = aplicaPermissoesPerfil(collection)
        collection = collection.limit(50);
        collection = collection.orderBy("dataStr", "desc");

        collection = filterCollection(collection, filters);
        setLoading(true)
        let observer = collection.onSnapshot(
            (qs) => {
                let lista = [];
                if (!qs.empty) {
                    qs.forEach((doc) => {
                        lista.push(doc.data());
                    });
                }

                setListaOriginal(lista);

                lista = filterList(lista, filters);
                lista.sort((a, b) => {
                    if (!a.sequencialIndex) return -1
                    if (!b.sequencialIndex) return 1
                    return b.sequencialIndex - a.sequencialIndex
                })
                setListaPesquisa(lista);
                setLoading(false)
                console.log("all visitas: ", lista.length);
                if (qs.metadata.fromCache) {
                    console.log("Consulta Apenas OFFLINE");
                } else {
                    console.log("Consulta ONLINE");
                }
            },
            (err) => {
                console.error(`createSnapCollection error: ${err}`);
            }
        );

        return () => {
            if (observer) observer();
            setListaPesquisa(null);
            setListaOriginal(null);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [uidVisita, filters, perfil]);

    const RenderCell = useCallback((props) => {
        const { coluna, linha, indexrow } = props;
        const editObj = (linha, indexrow) => {
            navigate("/visita?uid=" + linha.uid);
        };
        if ("COL_EDIT" === coluna.field) {
            return (
                <div style={{ display: "flex", justifyContent: "center", height: "100%" }}>
                    <IconButton size="small" onClick={() => editObj(linha, indexrow)}>
                        <Edit />
                    </IconButton>
                    {/* <ItemRelatorio fav dados={linha} prepareDados={initVisitaToRelatorio} modelo={RelatorioVisitaPadraOld} /> */}
                    <LaudoVisitaReportButton uid={linha.uid} />
                </div>
            );
        }

        if (coluna.Component) {
            return <coluna.Component {...props} />;
        }
        let value = _.get(linha, coluna.field);
        if (!value) {
            value = "";
        }
        if (coluna.field === "lastChange" && value.toDate) {
            try {
                let dateV = value.toDate();
                var dia = dateV.getDate().toString();
                var diaF = dia.length === 1 ? "0" + dia : dia;
                var mes = (dateV.getMonth() + 1).toString(); //+1 pois no getMonth() Janeiro começa com zero.
                var mesF = mes.length === 1 ? "0" + mes : mes;
                var anoF = dateV.getFullYear();
                var hora = dateV.getHours() < 10 ? "0" + dateV.getHours() : dateV.getHours();
                var minuto = dateV.getMinutes() < 10 ? "0" + dateV.getMinutes() : dateV.getMinutes();
                var segundos = dateV.getSeconds() < 10 ? "0" + dateV.getSeconds() : dateV.getSeconds();
                value = diaF + "/" + mesF + "/" + anoF + " - " + hora + ":" + minuto + ":" + segundos;
            } catch (error) {
                value = "";
            }
        }

        return <Typography component="div">{value || ""}</Typography>;
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getValueSort = (linha, coluna) => {
        if ("COL_TABLE_ACTIONS" === coluna.field) {
            return "";
        }
        const parseValueShow = (value, linha, coluna) => {
            if (value) {
                if (value.constructor === String) {
                } else if (value.constructor === Number) {
                } else if (value.toDate) {
                    //timestamps                           net
                    value = value.toDate().toISOString();
                } else if (value.constructor === Object) {
                    if (coluna && coluna.funcToString) {
                        value = coluna.funcToString(value, linha, coluna);
                        value = parseValueShow(value, linha);
                    } else {
                        value = JSON.stringify(value);
                    }
                }
            }
            return value;
        };
        let value = _.get(linha, coluna.field);

        value = parseValueShow(value, linha, coluna);
        return value;
    };

    const lastMonth = new Date();
    lastMonth.setDate(lastMonth.getDate() - 30);



    const extraQueryCliente = (col) => {


        if (perfil) {
            if (tipoPerfil === "cliente") col = col.where('perfisAutorizado.' + perfil.uid, '==', true);
            if (tipoPerfil === "tecnico") col = col.where('perfisAutorizado.' + perfil.uid, '==', true);
            if (tipoPerfil === "lider") {
                // se mais de 10 clientes, pode ser que precisaremos de uma nova abordagem
                // existe um limitador de 10 no operador 'in'
                if (perfil.clientesPermitidos && Array.isArray(perfil.clientesPermitidos) && perfil.clientesPermitidos.length > 0) {
                    col = col.where('uid', 'in', perfil.clientesPermitidos.map(cliente => cliente.uid))
                }
            }
        }
        return col;
    }
    return (
        <div>
            <DialogRelatorios
                showDialog={showDialogRelatorios}
                setShowDialog={setShowDialogRelatorios}
                modelosRelatorios={[RelatorioResumoGemas]}
                dados={listaPesquisa}
            />
            {/* <Filtros listaOriginal={listaOriginal} listaPesquisa={listaPesquisa} setListaPesquisa={setListaPesquisa} /> */}
            <DataFilter autocompleteOptions={listaOriginal} filters={filters} setFilters={setFilters}>
                <DataFilterCollection
                    label="Cliente"
                    name="cliente"
                    extraQuery={extraQueryCliente}
                    collection={getColDataCustomForm({ uid: "bsCJi5q1HonJ4ZgKYZUi" })} // TODO: remover hardcoded uid.
                    fieldValue="nome"
                    // required
                    databaseFilter
                    doFilter={(col, filter) => {
                        col = col.where("cliente.uid", "==", filter.value.uid);

                        return col;
                    }}
                    sx={{ mr: 1, width: { xs: "100%", sm: "calc(100% - 162px * 2)" } }}
                />

                <DataFilterDatePicker
                    label="Data Inicial"
                    name="dataInicio"
                    defaultValue={lastMonth}
                    required
                    databaseFilter
                    doFilter={(col, filter) => {
                        let data = filter.value;
                        data = data.replaceAll("-", "");
                        // TODO: migrar o tipo no DB para timestamp.
                        col = col.where("dataStr", ">=", data);
                        return col;
                    }}
                    sx={{ width: { xs: "100%", sm: "150px" } }}
                />
                <DataFilterDatePicker
                    label="Data Final"
                    name="dataFim"
                    defaultValue={new Date()}
                    required
                    databaseFilter
                    doFilter={(col, filter) => {
                        let data = filter.value;
                        data = data.replaceAll("-", "");
                        col = col.where("dataStr", "<=", data);
                        return col;
                    }}
                    sx={{ width: { xs: "100%", sm: "150px" } }}
                />

                <DataFilterTextField
                    label="Status"
                    name="status"
                    sx={{ mr: 1, width: { xs: "100%", sm: "calc(50% - 8px)" } }}
                />
                <DataFilterTextField
                    label="Visita Nº"
                    name="sequencialIndex"
                    sx={{ width: { xs: "100%", sm: "50%" } }}
                />
                <DataFilterTextField label="Técnico" name="tecnico.nome" />
                <DataFilterTextField label="Fazenda" name="fazenda.nomeFazenda" />
            </DataFilter>

            {listaPesquisa ? (
                <Tabela
                    sortColuns={true}
                    getValueSort={getValueSort}
                    data={listaPesquisa || []}
                    columns={colunas}
                    msgSemRegistro={"Sem Registros"}
                    onRowClick={(item, index) => {
                        console.log('onRowClick', item)
                    }}

                    rowsPer={15}
                    RenderCell={RenderCell}
                />
            ) : (
                <Box sx={{ m: 2, display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>
                    <Typography>{filters ? "Carregando..." : "Buscando ultimas Visitas... Selecione um cliente e período acima para filtrar."}</Typography>
                    {loading && <Box sx={{ m: 2, }}><CircularProgress /> </Box>}
                </Box>
            )}
            <DebugCSV />
            <DebugCSVIndicadores />
            <DebugCSVTipoIndicadores />
        </div>
    );
}
